var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", [
      _c("h3", { staticClass: "text-center" }, [
        _vm._v("เอกสารแสดงความยินยอมให้เปิดเผยข้อมูลส่วนบุคคล")
      ]),
      _vm._v(" "),
      _c(
        "h5",
        {
          staticClass: "text-right",
          staticStyle: { "font-size": "1rem", "font-weight": "bold" }
        },
        [_vm._v("วันที่ " + _vm._s(_vm._f("prettyOnlyDate")(_vm.toDate)))]
      )
    ]),
    _vm._v(" "),
    _c("pre", [
      _vm._v(
        "      ภายใต้ข้อตกลงการทำงาน บริษัท บีนีท จำกัด จำเป็นต้องเก็บ รวบรวม และใช้ข้อมูลส่วนบุคคลบางประเภทของผู้ให้บริการที่อาจพิจารณาเป็นข้อมูลส่วนบุคคลอ่อนไหวตามนิยามที่ระบุไว้ในกฎหมายที่เกี่ยวข้อง หรือพิจารณาเป็นกิจกรรมที่มีความจำเป็นต้องได้รับความยินยอมจากท่าน บริษัทจึงมีจุดประสงค์ขอความยินยอมจากผู้ให้บริการ ทั้งนี้ บริษัทรับประกันจะประมวลผลข้อมูลส่วนบุคคลทั้งหมดตามเงื่อนไขนโยบายข้อมูลส่วนบุคคลสำหรับผู้ให้บริการที่บริษัทได้ประกาศไว้ \n    "
      )
    ]),
    _vm._v(" "),
    _c("pre", [
      _vm._v("      ข้าพเจ้า นาง/นางสาว "),
      _c("span", [
        _vm._v(
          _vm._s(_vm.professional.title_th) +
            " " +
            _vm._s(_vm.professional.firstname_th) +
            " " +
            _vm._s(_vm.professional.lastname_th)
        )
      ]),
      _vm._v(" เกิดวันที่ "),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm._f("prettyOnlyDate")(_vm.professional.birthday)))
      ]),
      _vm._v(" บัตรประจำตัวประชาชนเลขที่ "),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm.professional.id_card_number))
      ]),
      _vm._v(" อยู่บ้านเลขที่ "),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm.professional.house_no))
      ]),
      _vm._v(" ถนน "),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm.professional.road))
      ]),
      _vm._v(" ตำบล/แขวง "),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(
          _vm._s(
            _vm.professional.sub_district
              ? _vm.professional.sub_district.name_th
              : "-"
          )
        )
      ]),
      _vm._v(" อำเภอ/เขต "),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(
          _vm._s(
            _vm.professional.district ? _vm.professional.district.name_th : "-"
          )
        )
      ]),
      _vm._v(" จังหวัด "),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(
          _vm._s(
            _vm.professional.address_province
              ? _vm.professional.address_province.name_th
              : "-"
          )
        )
      ]),
      _vm._v(" หมายเลขโทรศัพท์มือถือ "),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(
          _vm._s(_vm.professional.phone ? "0" + _vm.professional.phone : "")
        )
      ]),
      _vm._v(" E-mail (ถ้ามี) "),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm.professional.email))
      ]),
      _vm._v(" หมายเลขผู้ให้บริการอิสระเลขที่ "),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm.professional.id))
      ]),
      _vm._v("\n    ")
    ]),
    _vm._v(" "),
    _c("pre", [
      _vm._v(
        "      ทั้งนี้ ก่อนการแสดงเจตนา ข้าพเจ้าได้อ่านรายละเอียดจากเอกสารชี้แจงข้อมูล หรือได้รับคำอธิบายจากบริษัท บีนีท จำกัด ถึงนโยบายคุ้มครองข้อมูลส่วนบุคคลในการเก็บรวบรวม ใช้หรือเปิดเผย (“ประมวลผล”) ข้อมูลส่วนบุคคล และมีความเข้าใจดีแล้ว\n    "
      )
    ]),
    _vm._v(" "),
    _c("pre", [
      _vm._v(
        "[ ] ข้าพเจ้ายินยอมให้บริษัทเก็บ รวบรวม ใช้ ข้อมูลศาสนา ประวัติอาชญากรรม และข้อมูลสุขภาพที่ปรากฏในใบสมัครงาน ประวัติ การฉีดวัคซีน Covid-19 รวมถึงผลตรวจ ATK เพื่อบริษัทจะได้ดำเนินการประเมินความเหมาะสมก่อน และระหว่าง การปฏิบัติงานให้บริการแก่ผู้ใช้บริการ และยินยอมให้บริษัทส่งต่อเปิดเผยข้อมูลดังกล่าว โดยเฉพาะข้อมูลสุขภาพให้แก่ ผู้ใช้บริการ เพื่อประโยชน์ในการเลือกใช้บริการ ซึ่งข้าพเจ้ารับทราบว่า ข้อมูลดังกล่าวถือเป็นเงื่อนไขสำคัญสำหรับการ ให้บริการผ่านทางแพลตฟอร์ม\n\n[ ] ข้าพเจ้ายินยอมให้บริษัทเก็บ รวบรวม ใช้ข้อมูลส่วนบุคคลของข้าพเจ้า ได้แก่ ภาพถ่าย ภาพเคลื่อนไหวของข้าพเจ้า เพื่อจัดทำสื่อ ประชาสัมพันธ์หลายรูปแบบของบริษัท\n\n[ ] ข้าพเจ้ายินยอมให้บริษัทส่งต่อเปิดเผยข้อมูลส่วนบุคคลทั้งหมดของข้าพเจ้า รวมถึงแต่ไม่จำกัดเพียง ข้อมูลสุขภาพ และข้อมูลอื่นที่ ปรากฏตามใบสมัครงานแก่บริษัทในเครือ เพื่อให้บริษัทดังกล่าวใช้ข้อมูลนั้นมาติดต่อข้าพเจ้ากรณีมีตำแหน่งงานที่น่าสนใจ\n\n[ ]\tข้าพเจ้า (1) เข้าใจและรับทราบนโยบายข้อมูลส่วนบุคคลผู้สมัครงานที่บริษัทประกาศ และ (2) รับรองว่าข้อมูลทั้งหมดที่ข้าพเจ้าให้ภายใต้ใบสมัครงานนั้นถูกต้องและเป็นจริง และสำหรับข้อมูลส่วนบุคคลของบุคคลอื่นที่ข้าพเจ้าได้นำส่งให้แก่บริษัท ข้าพเจ้ารับรองว่า ข้าพเจ้ามีสิทธิและ/หรือได้รับความยินยอมจากเจ้าของข้อมูลที่เกี่ยวข้องในการส่งต่อเปิดเผยข้อมูลของบุคคลดังกล่าวให้แก่บริษัทเพื่อประโยชน์ในการประมวลผลอย่างเหมาะสม\n[ ] ข้าพเจ้าให้ความยินยอมในเอกสารนี้ด้วยความสมัครใจ ปราศจากการบังคับหรือชักจูง และข้าพเจ้าทราบว่าข้าพเจ้าสามารถถอนความยินยอมนี้เสียเมื่อใดก็ได้เว้นแต่ในกรณีมีข้อจำกัดสิทธิตามกฎหมายหรือยังมีสัญญาระหว่างข้าพเจ้ากับบริษัท บีนีท จำกัด ที่ให้ประโยชน์แก่ข้าพเจ้าอยู่\n\nกรณีที่ข้าพเจ้าประสงค์จะขอถอนความยินยอม ข้าพเจ้าทราบว่าการถอนความยินยอมอาจจะมีผลทำให้ ข้าพเจ้าอาจได้รับความสะดวกในการใช้บริการน้อยลง หรือ ไม่สามารถเข้าถึงฟังก์ชันการใช้แพลตฟอร์มของบีนีทบางอย่างได้ เป็นต้น และข้าพเจ้าทราบว่าการถอนความยินยอมดังกล่าว ไม่มีผลกระทบต่อการประมวลผลข้อมูลส่วนบุคคลที่ได้ดำเนินการเสร็จสิ้นไปแล้วก่อนการถอนความยินยอม\n    "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "text-right" }, [
      _c("div", { staticClass: "d-inline-block" }, [
        _c("div", { staticClass: "p-0" }, [
          _vm._v("\n          ลงชื่อ "),
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(
              _vm._s(_vm.professional.firstname_th) +
                " " +
                _vm._s(_vm.professional.lastname_th)
            )
          ]),
          _c("br"),
          _vm._v("\n          ( "),
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(
              _vm._s(
                _vm.professional.title_th +
                  " " +
                  _vm.professional.firstname_th +
                  " " +
                  _vm.professional.lastname_th
              )
            )
          ]),
          _vm._v(" )\n        ")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d67e8ec", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d67e8ec","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/contract/ConsentToDisClose.vue
// module id = 2045
// module chunks = 0